module.exports = __webpack_public_path__ + "static/media/b4-放生桥.28f721ba.png";